// importeer hier alle scripts die je maakt

import "./utils/favicon.js";
import "./utils/boxSizing.js";
import "./alpine/alpine.js";
import "./animations/animations.js";
import "./components/swiper.js";
import "./components/language-switcher.js";
import "./components/leisure-popup.js";
import "./components/academy-app.js";
import "./components/embed-resize.js";
import "./vendor/iubenda.js";
import "./vendor/ga-slug.js";
import "./helpers/lazyImgs.js";

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {});
Fancybox.bind("[data-fancybox='gallery']", {});
